export const API_BE = "https://www.apiwhatismyip.com/api";
export const BLOCK_ORG = [];
export const GOOGLE_API_KEY = "6LfpugMqAAAAAM3q9dzBI29-g4gYi1usMg9WIn1R";
